import SchemeDrawingList from '&/components/SchemeDrawing/list';

export default function DrawingCommentList() {
    return <SchemeDrawingList isHDD={true} />;
}
